import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {APIStatus} from '@web/core/constants'
import {
    getAiTEMS,
    updateAdStatus,
    updateAiTEMSPage,
    convertTabInfo,
    getInitialState,
    AiTEMSState,
    AiTEMSAdStatus as AdStatus,
} from '@web/slices/aitems/slice'

import {MakeSliceOptions, AiTEMSReducers} from './interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<AiTEMSState, AiTEMSReducers, 'aitems', SliceSelectors<AiTEMSState>>({
        name: 'aitems',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(getAiTEMS.pending, (state) => {
                    state.fetchStatus = APIStatus.FETCHING
                })
                .addCase(getAiTEMS.fulfilled, (state, {payload}) => {
                    state.tabs = convertTabInfo(payload.tabs)
                    state.fetchStatus = APIStatus.RESOLVED
                })
                .addCase(getAiTEMS.rejected, (state) => {
                    state.fetchStatus = APIStatus.REJECTED
                    state.adStatus = AdStatus.ERROR
                })
                .addCase(updateAiTEMSPage, (state, {payload}) => {
                    state.page = payload
                })
                .addCase(updateAdStatus, (state, {payload}) => {
                    state.adStatus = payload
                })
            options?.extraReducers?.(builder)
        },
    })
